/**
 * @name robot-arm
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjEgNy41IDguMzIyIiAvPgogIDxwYXRoIGQ9Im0xNCA3IDEuNzUtMy43NjdhLjUuNSAwIDAgMSAuNjYyLS4xNzJMMjAgNS4wMDUiIC8+CiAgPHBhdGggZD0ibTIwIDguOTk4LTMuNTg4IDEuOTQ0YS41LjUgMCAwIDEtLjY2Mi0uMTcyTDE0IDdIOCIgLz4KICA8cGF0aCBkPSJNMy40ODYgMjFoMTAiIC8+CiAgPHBhdGggZD0iTTUgMjFWOC43MzIiIC8+CiAgPGNpcmNsZSBjeD0iNiIgY3k9IjciIHI9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/robot-arm
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const RobotArm: string = `
<svg
  class="lucide lucide-robot-arm"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 21 7.5 8.322" />
  <path d="m14 7 1.75-3.767a.5.5 0 0 1 .662-.172L20 5.005" />
  <path d="m20 8.998-3.588 1.944a.5.5 0 0 1-.662-.172L14 7H8" />
  <path d="M3.486 21h10" />
  <path d="M5 21V8.732" />
  <circle cx="6" cy="7" r="2" />
</svg>
`;

export default RobotArm;
